<template>
  <div id="post">

    <div class="scroll">
      <div :class="{pinned: $store.state.isDesktop}">

        <Slider ref="slider" class="slider" v-if="image">
          <div class="slide" :style="{'background-image': 'url(' + image + ')'}"></div>
          <!-- <div class="slide" :style="{'background-image': 'url(babillard.jpg)'}"></div>
          <div class="slide" :style="{'background-image': 'url(babillard.jpg)'}"></div> -->
        </Slider>

        <div class="dots" v-if="$refs.slider && $refs.slider.getPageCount() > 1">
          <div class="dot" v-for="(n, index) in $refs.slider.getPageCount()" :key="index" :class="{active: $refs.slider.getPage == index}"></div>
        </div>

        <div class="content" v-if="post" :class="{pending: post.status != 'accepted'}">
          <div class="title">{{ $to(post.title) }}</div>
          <div class="subtitle">{{ $to(post.subTitle) }}</div>
          <div class="date">{{ formatDate(post.createdAt) }}</div>
          <div class="description">{{ $to(post.body) }}</div>

          <div class="statusReason" v-if="post.status != 'published'">
            <div class="status">{{ $t("status") }} : {{ $t("billboard.status." + post.status) }}</div>
            <div class="reason" v-if="post.status == 'rejected' && post.decisionNote">{{ $t("reason") }} : {{ post.decisionNote }}</div>
          </div>

<!--          <div v-show="$store.state.isDesktop" Class="buttonDesktop">-->
<!--            <div class="btn btn-secondary" @click="toBillboard">{{ $t("billboard.back") }}</div>-->
<!--          </div>-->


        </div>


      </div>
    </div>


    <div class="buttons" :class="{buttonDesktop: $store.state.isDesktop }">
      <div class="btn btn-secondary" @click="toBillboard">{{ $t("billboard.back") }}</div>
       <div class="btn btn-primary" v-if="isCurrentUser" @click="removePost">{{ $t("billboard.remove") }}</div>
    </div>
  </div>
</template>

<script>

  import Billboard from '../../core/Billboard';
  import User from '../../core/User';
  import Slider from "../components/Slider.vue";

  export default {

    name: "post",

    components: { Slider },

    data() {
      return {
        Billboard,
        User
      };
    },

    mounted() {
      
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: this.post ? this.$to(this.post.title) : "page.news",
        headerIcon: "/svg/news.svg"
      });
      
      setTimeout(()=>this.$forceUpdate(),0);
    },

    watch: {
      post() {
        this.$store.state.headerTitle = this.$to(this.post.title);
      }
    },

    computed: {
      post() {
        return this.Billboard.get(this.$route.params.id);
      },
      isCurrentUser() {
        return this.User.id === this.post.author;
      },
      image() {
        if (this.post && this.post.image != null) {
          return CONFIG.urlFiles + this.post.image;
        }
        return "";
      }
    },

    methods: {
      toBillboard() {
        this.$router.push("/billboard");
      },
      formatDate(date) {
       if (this.$ts.state.locale == "en") {
          return date.format("MMMM DD, YYYY | HH:mm");
        }
        return date.format("DD MMMM YYYY | HH:mm");
      },
      async removePost() {
        this.post.status = "finished";
        showSpinner();
        let result = await this.Billboard.removePost(this.post);
        hideSpinner();
        if (result.status == 200) {
          this.$router.push("/billboard");
        }
      },
    }

  }

</script>

<style lang="scss" scoped>

  #post {
    background-color: #f2f3f4;
    display: flex;
    flex-direction: column;
  }

  .scroll {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .slider {
    height: 200px;
    background-color: white;
    .slide {
      background-size: cover;
      background-position: center;
    }
  }

  .content {
    padding: 20px;
    &.pending {
      .description {
        margin-bottom: 20px;
      }
      .statusReason {
        margin-bottom: 40px;
      }
    }
  }

  .title {
    font-size: 20px;
  }

  .subtitle {
    color: #666666;
    font-size: 18px;
    margin-bottom: 4px;
  }
  .date {
    color: #808b91;
    font-size: 14px;
    margin-top: 6px;
    margin-bottom: 20px;
  }

  .description {
    margin-bottom: 40px;
  }

  .buttons {
    display: flex;
    padding: 20px;
    align-items: flex-end;
    .btn {
      /*min-width:0;*/
      /*min-width:175px;*/
      flex-basis: 0;
      &:not(:last-of-type) {
        margin-right: 20px;
      }
    }
  }

  .dots {
    position: absolute;
    top: 170px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: white;
      border: 2px solid white;
      &.active {
        background-color: black;
      }
      &:not(:last-of-type) {
        margin-right: 10px;
      }
    }
  }

  /* MOBILE ONLY RULES */
  @media screen and (max-width: 600px) {

    .btn {
      flex-grow: 1;
    }
  }

  /* DESKTOP ONLY RULES */
  @media screen and (min-width: 601px) {
    #post {
      background-color: #f2f3f4;
      padding: 30px 60px 30px 60px ;

      .pinned {
        flex-direction: row;
        background-color: white;
        margin-bottom: 20px;
        border-radius: 3px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        display: flex;
        padding: 30px;

        .slider {
          flex-shrink: 0;
          height: 280px;
          max-height: 280px;
          width: 434px;
          max-width: 434px;
          background-color: white;
          .slide {
            background-size: cover;
            background-position: center;
          }
        }
        .content {
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          .title {
            font-size: 22px;
            font-weight: 500;
          }
          .description {
            font-size: 18px;
            flex-grow: 1;
          }
        }
      }
    }

    .buttons {
      padding: 20px 0;
    }
    .btn {
      min-width: 175px;
    }

    .buttonDesktop {
      display: flex;
      justify-content: flex-start;
    }

  }
</style>